import { Component, Input } from '@angular/core';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';
import { FormGroup } from '@angular/forms';
import { Icd10CodeDto } from '../../../../../service/dto';
import { debounceTime, distinctUntilChanged, filter, finalize, Subject, switchMap, takeUntil } from 'rxjs';
import { HttpIcd10Service } from '../../../../../service/http-icd10.service';

@Component({
	selector: 'app-dynamic-form-input-icd10',
	standalone: false,
	templateUrl: './dynamic-form-input-icd10.component.html',
	styleUrl: './dynamic-form-input-icd10.component.scss'
})
export class DynamicFormInputIcd10Component {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	@Input() span = 0;
	toControlKey = AbstractDynamicForm.toControlKey;

	suggestions: Icd10CodeDto[] = [];
	isLoading = false;

	private searchSubject = new Subject<string>();
	private destroy$ = new Subject<void>();

	constructor(private icd10Service: HttpIcd10Service) { }

	ngOnInit(): void {
		this.searchSubject.pipe(
			debounceTime(350),
			distinctUntilChanged(),
			filter(term => term.length >= 2),  // don't search on very short input
			switchMap(term => {
				this.isLoading = true;
				return this.icd10Service.search(term).pipe(
					finalize(() => this.isLoading = false)
				);
			}),
			takeUntil(this.destroy$)
		).subscribe(results => {
			this.suggestions = results;
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	onSearch(term: string): void {
		if (!term) {
			this.suggestions = [];
			return;
		}
		this.searchSubject.next(term);
	}

	getLabel(opt: Icd10CodeDto): string {
		return `${opt.icd_10_code} – ${opt.whoFullDescription || opt.icd_10_3_code_desc}`;
	}
}
